/**
 * List of all the singleton documents that we use as constants.
 * Singleton documents are special documents, where we want one specific document (per locale),
 * but of a non-singleton schema.
 *
 * For example, the Homepage is a "DOCUMENT.PAGES" type, which is not a singleton, but the homepage
 * is treated as a singleton, in that it's not shown in the list of pages, and has its own menu
 * item in the desk structure.
 *
 * NOTE the below strings MUST NOT include a dot `.` - this is because they are used to generate
 * Sanity document IDs, and having a dot in the path name will make the document private.
 *
 * For more info please see the deskTool documentation at `apps/sanity/docs/deskTool.md`.
 */

export enum SINGLETON_DOCUMENT {
  HOMEPAGE = 'homepage',
  /** Business workspace site root homepage (distinct from WWW `pages` homepage). */
  BUSINESS_HOMEPAGE = 'business-homepage',
  /** Business soft-404 page (same schema as business homepage, distinct singleton id). */
  BUSINESS_PAGE_404 = 'business-page-404',
  ABOUT_FOOD_WASTE_HOME = 'about-food-waste-home',
  ABOUT_FOOD_WASTE_BLOG_HOME = 'about-food-waste-blog-home',
  ABOUT_FOOD_WASTE_RESOURCES_HOME = 'about-food-waste-resources-home',
  ABOUT_US_HOME = 'about-us-home',
  BUSINESS_SOLUTIONS_HOME = 'business-solutions-home',
  MARKETPLACE_HOME = 'marketplace-home',
  PARCELS_HOME = 'parcels-home',
  PLATFORM_HOME = 'platform-home',
  DATE_LABELLING_HOME = 'date-labelling-home',
  DONATIONS_HOME = 'donations-home',
  CAREERS_HOME = 'careers-home',
  LEGAL_HOME = 'legal-home',
  SUPPORT_HOME = 'support-home',
  PAGE_404 = 'page-404',
  SOLUTION_FINDER = 'solution-finder',
  SOLUTION_FINDER_FALLBACK = 'solution-finder-fallback',
  PRESS_HOME = 'press-home',
  BLOG_SINGLE_DEFAULT_BLOCKS = 'about-food-waste-blog-single-default-blocks',
  PRESS_RELEASE_DEFAULT_BLOCKS = 'press-releases-single-default-blocks',
  INITIATIVES_HOME = 'initiatives-home',
  INITIATIVE_B2B_HOME = 'initiative-b2b-home',
  ACQUISITION_B2B_HOME = 'acquisition-b2b-home',
  ACQUISITION_B2C_HOME = 'acquisition-b2c-home',
  SURPRISE_BAG_HOME = 'surprise-bag-home',
  SURPRISE_BAG_PAGES = 'surprise-bag-pages',
  BRAND_PROFILE_HOME = 'brand-profile-partners-home',
}
